/**
 * Created by koqiui on 2017-04-09.
 */
import { Vue } from '../../app.vues';
import { Utils } from '../../app.base'

import comnApi from '../../api/comn'
//
import SwbRegionForSelect from './RegionForSelect';
Vue.regist(SwbRegionForSelect);
//
import SwbRegionSelect from './RegionSelect';
Vue.regist(SwbRegionSelect);
export function openRegionSelectDlg(itemList, level, callback) {
    //
    Vue.$showDialog({
        title: '地址 - 选择',
        showCloseBtn: true,
        width: 700,
        height: 600,
        template: '<div>' +
        '<swb-region-select :regionList="regionList" :level = "level" ref="swb_region_select"></swb-region-select>' +
        '</div>',
        data: {
            level: null,
            regionList: [],
        },
        okClicked: function () {
            let result = this.$refs.swb_region_select.getDlgResult() || {};
            if(result.type == "info") {
                let regionList = result.data;
                //
                callback(regionList);
            } else {
                return false;
            }
        },
        lifecycle: {
            created: function () {
                this.regionList = itemList;
                this.level = level || 3;
            }
        },
    });
}

// 地区选择组件 -- 下拉选
export function openRegionForSelectDlg(args = {}, callback) {
    //
    let checkedProvinceId = args['provinceId'] || null;
    let checkedCityId = null;
    let checkedCountyId = null;
    if(checkedProvinceId != null) {
        checkedCityId = args['cityId'] || null;
        if(checkedCityId != null) {
            checkedCountyId = args['countyId'] || null;
        }
    }
    //
    Vue.$showDialog({
        title: '地区 - 选择',
        showCloseBtn: true,
        width: 600,
        height: 300,
        template: '<div>' +
        '<swb-region-for-select :checkedProvinceId="checkedProvinceId" :checkedCityId="checkedCityId" :checkedCountyId="checkedCountyId" ref="swb_region_for_select"></swb-region-for-select>' +
        '</div>',
        data: {
            checkedProvinceId: checkedProvinceId,
            checkedCityId: checkedCityId,
            checkedCountyId: checkedCountyId,
        },
        okClicked: function () {
            let result = this.$refs.swb_region_for_select.getDlgResult() || {};
            if(result.type == "info") {
                let region = result.data;
                let ids = [];
                ids.add(region.provinceId);
                ids.add(region.cityId);
                ids.add(region.countyId);
                let postData = {
                    ids: ids
                };
                comnApi.getRegionListByIds(postData, function (regionRes, jqXhr) {
                    if(regionRes.type == "info") {
                        let regionList = regionRes.data || [];
                        let regionName = null;
                        for(let i = 0; i < regionList.length; i++) {
                            let regionObj = regionList[i];
                            if(Utils.isNoB(regionName)) {
                                regionName = regionObj.name;
                            } else {
                                regionName += " " + regionObj.name;
                            }
                        }
                        region.regionName = regionName;
                        //
                        callback(region);
                    } else {
                        MsgBox.error(regionRes.message);
                        return false;
                    }
                });
            } else {
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}






//////////////////
// WEBPACK FOOTER
// ./src/compo/comn/regionSelectDlg.js
// module id = 65
// module chunks = 1